import AuthService from '../services/authService';

const STORAGE_KEY = 'selectedCompany';

/** Read selected company from localStorage (shared key with tahsis). */
export const getStoredSelectedCompany = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/** Build base64 SSO hash payload for cross-app navigation. */
export const buildSsoHash = (selectedCompany = null) => {
  const token = AuthService.getAuthToken();
  const refreshToken = AuthService.getRefreshToken();
  const userData = AuthService.getCurrentUser();
  if (!token || !userData) return null;

  const rememberMe = !!localStorage.getItem('authToken');
  const company = selectedCompany ?? getStoredSelectedCompany();
  const payload = { token, refreshToken, userData, rememberMe };
  if (company?.id) payload.selectedCompany = company;

  return `#sso=${btoa(JSON.stringify(payload))}`;
};

/**
 * Apply inbound SSO from URL hash. Returns true if a payload was processed.
 * Call once on app boot before auth-gated UI renders.
 */
export const applySsoFromHash = () => {
  const hash = window.location.hash;
  if (!hash.startsWith('#sso=')) return false;

  try {
    const raw = atob(hash.slice(5));
    const { token, refreshToken, userData, rememberMe, selectedCompany } = JSON.parse(raw);
    if (token && userData) {
      AuthService.setAuthData(token, userData, rememberMe || false, refreshToken);
      if (selectedCompany?.id) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedCompany));
        localStorage.setItem('selectedCompanyId', String(selectedCompany.id));
      }
      window.dispatchEvent(new Event('userLogin'));
    }
  } catch {
    // Malformed SSO payload
  }

  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  return true;
};
